import { render } from "./DimensionTabContent.vue?vue&type=template&id=7691140a&ts=true"
import script from "./DimensionTabContent.vue?vue&type=script&lang=ts"
export * from "./DimensionTabContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__